import React from "react";

import Collapsible from "react-collapsible";

import TextareaAutosize from "react-autosize-textarea";
import Tooltip from "./Tooltip";

export default class Toggle extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  render() {
    let { id, checked, title, tooltip, onChange } = this.props;

    return (
      <div class="row">
        <div class="col-md-9">
          <h4>
            {title}
            {tooltip && <Tooltip text={tooltip} />}
          </h4>
        </div>
        <div class="col-md-3 text-right">
          <div class="input-checkbox input-checkbox--switch">
            <input
              id={id}
              type="checkbox"
              checked={checked}
              onChange={(e) => onChange(e.target.checked)}
            />
            <label for={id}></label>
          </div>
        </div>
      </div>
    );
  }
}

Toggle.defaultProps = {};
